export function getPreferenceFromWindow (key: string): string | undefined {
  const varFromWindow = ((window as any)[key] || '').trim();
  const isVarFromWindowEmpty = varFromWindow.startsWith('${') || varFromWindow === '';
  const definedValue = isVarFromWindowEmpty ? process.env[key] : varFromWindow;
  return definedValue;
}
